import type { ReactNode } from "react";
import { CalendarDays } from "lucide-react";
import type { DashboardData, Owner, Recurring } from "../../../types";
import { money } from "../../../lib/finance";
import { upcoming } from "../overview-data";

/** "On the horizon": the bills and regular income coming up. */
export default function Upcoming({ data, owner, today, collapsed, collapseButton, onPayBill }: {
  data: DashboardData;
  owner: Owner | "All";
  today: string;
  collapsed: boolean;
  /** The module's collapse toggle, drawn by the caller so every module's matches. */
  collapseButton: ReactNode;
  /** Opens the pay flow for one of the bills listed. */
  onPayBill: (bill: Recurring) => void;
}) {
  const recurring = upcoming(data, owner);
  return (
    <section className={`panel upcoming-panel overview-module${collapsed ? " is-collapsed" : ""}`}>
      <div className="section-heading">
        <div>
          <h2>On the horizon</h2>
          <p>Upcoming bills and income</p>
        </div>
        <div className="overview-heading-actions"><span className="collapsed-summary">{recurring.length} upcoming</span><CalendarDays size={19} />{collapseButton}</div>
      </div>
      {recurring.length ? (
        recurring.map((r) => (
          <button type="button" className="recurring-row" key={r.id} onClick={() => onPayBill(r)}>
            <span className="date-tile">
              <strong>
                {Number(r.nextDue.slice(8, 10))}
              </strong>
              <small>
                {new Date(
                  r.nextDue.slice(0, 10) + "T12:00:00",
                ).toLocaleDateString("en-GB", {
                  month: "short",
                })}
              </small>
            </span>
            <span>
              <strong>{r.name}</strong>
              <small>
                {r.owner} · {r.frequency}
                {r.nextDue.slice(0, 10) < today
                  ? r.type === "Income" ? " · Late" : " · Overdue"
                  : ""}
              </small>
            </span>
            <strong>{r.amount > 0 ? `${r.type === "Income" ? "+" : ""}${money(r.amount, r.currency)}` : "Varies"}</strong>
          </button>
        ))
      ) : (
        <p className="muted empty-small">
          Nothing recurring scheduled.
        </p>
      )}
    </section>
  );
}
